import React, { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from "@mui/material/Slide";
import AppBarDialog from "./AppBar";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DialogoIngresosBrutos(props) {
    return (
       <div>
            <Dialog
                fullScreen
                open={props.open}
                onClose={props.handleClose}
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        backgroundColor: "#ebebeb",
                    },
                }}
            >
                <AppBarDialog
                    cliente={props.cliente}
                    handleClose={props.handleClose} 
                    preparar={props.preparar}
                />
                <DialogContent
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        bgcolor: "#f5f5f5",
                        display: "flex",
                        flexDirection: "column",
                        gap: 0,
                        p: 0,
                    }}
                >
                    {props.children}
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default DialogoIngresosBrutos
